import { useEffect, useRef, useState } from "react"
import { AppText, AppTextProps } from "~/ui/app-text"
import { FormattedAppText } from "~/ui/formatted-app-text"

// Literal class names so Tailwind's JIT can see them.
const CLAMP_CLASS: Record<number, string> = {
  4: "line-clamp-4",
  10: "line-clamp-[10]",
}

interface ClampedMessageTextProps {
  text: string
  variant?: AppTextProps["variant"]
  lineClamp: keyof typeof CLAMP_CLASS
}

export const ClampedMessageText: React.FC<ClampedMessageTextProps> = ({
  text,
  variant,
  lineClamp,
}) => {
  const [isClamped, setIsClamped] = useState(false)
  const textRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = textRef.current
    if (el) setIsClamped(el.scrollHeight > el.clientHeight)
  }, [text, lineClamp, variant])

  return (
    <div className="flex flex-col items-start gap-1">
      <FormattedAppText
        ref={textRef}
        text={text}
        variant={variant}
        className={`whitespace-pre-wrap ${CLAMP_CLASS[lineClamp]}`}
      />
      {isClamped && (
        <AppText variant={variant} className="text-base-blue">
          See More
        </AppText>
      )}
    </div>
  )
}
